import slideshow from './slideshow';

export default function videoFeature() {
  const $videoFeature = $('#videoFeature');

  if ($videoFeature.find('video').length) {
    $('.slideshow-wrapper').remove();
    return;
  }

  $videoFeature.remove();
  slideshow('slideshow', slideshowOpts);
}
